import { 
  LOAD_UNIT_ENUM_DATA_IN_PROGRESS,
  LOAD_UNIT_ENUM_DATA_SUCCESS,
  LOAD_UNIT_ENUM_DATA_FAILURE,
  OPEN_UNITS_AND_ENUMS_DIALOG,
  CLOSE_UNITS_AND_ENUMS_DIALOG,
  LOAD_UNIT_AND_ENUM_SINGLE_DATA,
  UNIT_ENUM_OPERATION_COMPLETED
} from "./actions";

const initialState = { isLoading: false, unitEnumData: [], unitEnumSingleData:[] };

export const unitAndEnumData = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_UNIT_ENUM_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        unitEnumData: data,
      };
    }
    case LOAD_UNIT_ENUM_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_UNIT_ENUM_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
      case UNIT_ENUM_OPERATION_COMPLETED:
        return {
            ...state,
            isLoading: false,
        }; 
      case OPEN_UNITS_AND_ENUMS_DIALOG:
        return {
          ...state,
          isUnitsAndEnumsDialogOpen: true,
        }; 

      case CLOSE_UNITS_AND_ENUMS_DIALOG:
        return {
          ...state,
          isUnitsAndEnumsDialogOpen: false,
        }; 
      case LOAD_UNIT_AND_ENUM_SINGLE_DATA:{
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            unitEnumSingleData : data,
        }
      }
      default:
        return state;
  }
};
